import _ from 'lodash'
import moment from 'moment'
import {JoinType, ListCountType} from 'rules-config'

const operationTypes = {
  number: 'numeric',
  string: 'text'
}

const converters = {
  FieldCondition: (c) => convertFieldCondition(c),
  JoinCondition: (c) => convertJoinCondition(c),
  ListCondition: (c) => convertListCondition(c)
}

export function toPublishObject(campaign) {
  let receiver = _.reduce(campaign.recipients, (acc, recipient) => {
    let recipientType = recipient.className.replace('Recipient', '').toLowerCase()
    let recipientObject = _.toPlainObject(recipient)
    delete recipientObject['className']
    acc[recipientType] = recipientObject
    return acc
  }, {})
  let joinCondition = campaign.rule.joinCondition
  let campaignPublishObj = {
    id: campaign.id,
    ruleId: campaign.id,
    name: campaign.name,
    isCampaignGrouper: campaign.isCampaignGrouper,
    groupCampaignId: campaign.groupCampaignId,
    priority: campaign.priority,
    eventType: _.head(campaign.rule.triggers),
    hasDirectLink: campaign.hasDirectLink,
    linkType: campaign.linkType,
    campaignFormName: campaign.campaignFormName,
    directLink: campaign.directLink,
    startDate: moment(campaign.startDate).utc().startOf('day').toISOString(),
    endDate: moment(campaign.endDate).utc().endOf('day').toISOString(),
    createdDate: moment(campaign.createdDate).utc().endOf('day').toISOString(),
    isEnabled: campaign.isEnabled,
    topic: _.head(campaign.topics),
    contentMode: campaign.contentMode,
    tenant: campaign.tenant,
    promotionUrls: campaign.promotionUrls,
    notification: {
      id: `${campaign.id}-${campaign.name}`,
      receiver
    },
    on: convert(joinCondition),
    ...getOffersToLoad(campaign)
  }

  if (campaign.rule.isBatch) {
    return _.extend(campaignPublishObj, getBatchRuleFields(campaign))
  } else {
    return campaignPublishObj
  }
}

export function getBatchRuleFields(campaign) {
  return {
    isBatch: true,
    eventType: 'batch',
    source: {
      resource: campaign.rule.batchRulesSource,
      query: '{}'
    }
  }
}

export function getOffersToLoad(campaign) {
  if (_.some(campaign.extraData.offers) || _.some(campaign.extraData.offerTags)) {
    return {
      extraData: {
        offers: _.map(campaign.extraData.offers, (o) => ({
          code: o.code
        })),
        offerTags: _.map(campaign.extraData.offerTags, (offerTag) => ({
          id: offerTag.id,
          name: offerTag.name
        }))
      }
    }
  } else {
    return {}
  }
}

export function convert(condition) {
  if (!condition) {
    return
  }
  let converter = converters[condition.className]
  return converter(condition)
}

export function convertFieldCondition(fieldCondition) {
  return {
    className: fieldCondition.className,
    negate: fieldCondition.negate,
    operationType: operationTypes[fieldCondition.operator.operatorType] ||
      fieldCondition.operator.operatorType,
    fieldAccessor: fieldCondition.fieldAccessor,
    value: fieldCondition.value,
    operator: fieldCondition.operator.name
  }
}

export function convertJoinCondition(joinCondition) {
  return {
    className: joinCondition.className,
    negate: joinCondition.negate,
    joinType: joinCondition.joinType === JoinType.AND ? 'all' : 'any',
    conditions: _(joinCondition.conditions).map((c) => convert(c)).flatten().value()
  }
}

export function convertListCondition(listCondition) {
  return {
    className: listCondition.className,
    negate: listCondition.negate,
    listAccessor: listCondition.listAccessor,
    countType: ListCountType[listCondition.countType],
    count: listCondition.count,
    condition: convert(listCondition.condition)
  }
}



// WEBPACK FOOTER //
// ./src/services/publish-format.service.js